// src/components/Products.js
import React from 'react';
import Ideapng from '../resorcesfiles/images/idea.png';
import './Products.css';
import Mainmastet from '../masterpage/Mainmastet';
import P80 from '../resorcesfiles/ideak/p80.jpg'
import U300 from '../resorcesfiles/ideak/u300.jpg'
import Cp30 from '../resorcesfiles/ideak/cp30.jpg'
import C72 from '../resorcesfiles/ideak/c72.jpg'
import Antenna from '../resorcesfiles/ideak/antenna.jpg'
import Laundrytags from '../resorcesfiles/ideak/laundrytags.jpeg'
import Keyfob from '../resorcesfiles/ideak/keyfob.jpeg'
import AnimalTag from '../resorcesfiles/ideak/animaltag.png'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';




const products = [

  {
    img:Cp30,
    shortName: 'Cp30',
    fullName: 'CP30 RFID Printer',
    description: 'Powerful RFID and Barcode Printing, Speedy and Highly Secured',
    paths:'ProductDetailsCP'
  },

];

const ProductsPrinter = () => {
  return (
    <Mainmastet content={<>
        <Helmet>
            <title>RFID Solutions in Kenya | Ziditech</title>
            <meta 
              name="description" 
              content={`Explore advanced RFID Printers, Readers, and access systems in Kenya from Ziditech.`} 
            />
            <meta name="keywords" content={`RFID Printers`} />
          </Helmet>
    
    
    <div className="products-container">
        <div style={{textAlign:'center'}}>
        <h1 style={{fontFamily:'fantasy'}}>PRINTERS</h1>
        </div>
      <div className="products-grid">
        {products.map((product, index) => (
        <Link to={`/${product.paths}`} key={index} className="product-item" style={{textDecoration:'none'}} > 
          {/* <div > */}
            <img src={product.img} alt={product.fullName} className="product-image" />
            {/* <h2 className="product-shortname">{product.shortName}</h2> */}
            <h3 className="product-fullname">{product.fullName}</h3>
            <p className="product-description">{product.description}</p>
          {/* </div> */}
        </Link>
    
        ))}
      </div>

      <div style={{height:'50px'}}></div>

    </div>

    </>} />
  );
};

export default ProductsPrinter;
